export default "__VITE_ASSET__D_ts9SWZ__"